import ICBonus from "./ic-bonus";
import gameState from "slotworks/model/game-state";
import betModel from "slotworks/model/bets/bet-model";
import Components from "slotworks/components/components";
import smartButton, { SmartButtonFlag } from "slotworks/smart-button/smart-button";
import { BetBarType } from "slotworks/components/betbar/bet-bar-component";
import Layers from "slotworks/graphics/layers/layers";
import settingsModel from "slotworks/model/settings/settings-model";
import DSComponents from "components/components";
import ICFreespinRecord from "integration/revolver/schema/freespin-record";
import BonusRecord from "integration/revolver/schema/bonus-record";
import regulation from "slotworks/integration/revolver/regulations/regulation";
import BetMenuFreespinsMediator from "slotworks/mediators/bet-menu-freespins-mediator";

export default class EnterRecoveryBonus extends ICBonus {

    public onEnter() {     
        Components.betBar.setBetOptions(betModel.generateBetOptions());

        DSComponents.coinPots.bankCoinsOnFreespin();

        const latest = gameState.getCurrentGame().getFirstRecord();
        if(latest instanceof ICFreespinRecord) {
            gameState.getCurrentGame().inFreespinsGame = true;
            this.recoverFreespinElementsAfterBonus();
        }

        regulation.interactionStart();
        super.onEnter();         
    }

    public complete() {
        this.recoverFreespinsIfNeeded();
        super.complete();
    }

    private recoverFreespinsIfNeeded() {
        const latest = gameState.getCurrentGame().latestRecord();

        if(latest instanceof ICFreespinRecord || (latest as BonusRecord).inFreespins) {

            const gameplay = gameState.getCurrentGame();

            smartButton.setFlag(SmartButtonFlag.FREE_SPINS, true);
            Components.betBar.setBetOptions(betModel.generateBetOptions());
            Components.betBar.setType(BetBarType.FREESPINS);
            
            new BetMenuFreespinsMediator().start().execute();
            
            Components.betBar.setTotalFreespins(latest.freespinsWon);
            
            Components.betBar.setRemainingFreespins(Math.max(0, gameplay.getTotalFreespinsWon() - 1));
            // Components.betBar.setRemainingFreespins(0);
            Components.betBar.winnings.setWinnings(latest.creditsWon, gameplay.totalCreditsWon);
            
            const homeButton = Layers.BetBar.getFlexiButton("home");
            const homeURL = settingsModel.homeURL;
            if (homeButton) {
                if (homeURL === "close" || homeURL === "" || homeURL === undefined || homeURL === null) {
                    homeButton.setVisible(false);
                } else {
                    homeButton.setVisible(true);
                }
            }            
            Components.betBar.setEnabled(false);
            // this.recoverFreespinElementsAfterBonus();
        }
    }

    private recoverFreespinElementsAfterBonus() {
        if (Layers.Background.hasScene("freespins")) {
            Layers.Background.jumpToScene("freespins");
        }
        if (Layers.MatrixBackground.hasScene("freespins")) {
            Layers.MatrixBackground.jumpToScene("freespins");
        }
        if (Layers.Header.hasScene("freespins")) {
            Layers.Header.jumpToScene("freespins");
        }

        Components.banner.setMode("freespins");
        Components.betBar.setType(BetBarType.FREESPINS);
    }
}